// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GuidLookupPagingResultModel from '../../model/guid-lookup-paging-result-model';
import GuidLookupPagingResultDTO from '../dto/guid-lookup-paging-result-dto';
import dtoSchema from '../schemas/guid-lookup-paging-result-schema';
import GuidLookupModel from '../../model/guid-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class GuidLookupPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GuidLookupPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => GuidLookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: GuidLookupModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<GuidLookupPagingResultDTO>): GuidLookupPagingResultModel;
  static toModel(dto: DeepPartial<GuidLookupPagingResultDTO> | undefined | null): GuidLookupPagingResultModel | undefined;
  static toModel(dto: DeepPartial<GuidLookupPagingResultDTO> | undefined | null): GuidLookupPagingResultModel | undefined {
    return dto ? new GuidLookupPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GuidLookupPagingResultModel> | GuidLookupPagingResultModel): GuidLookupPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as GuidLookupPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GuidLookupPagingResultModel, can not map to GuidLookupPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
